/* eslint-disable quote-props */
/* eslint-disable indent */
import { Helmet } from 'react-helmet-async';
import React from 'react';

import i18n from 'i18';

// @mui
import {
    Alert,
    Box,
    Card,
    CircularProgress,
    Container,
    IconButton,
    MenuItem,
    Paper,
    Popover,
    Snackbar,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Typography
} from '@mui/material';

// components
import Iconify from 'components/iconify';
import Scrollbar from 'components/scrollbar';
import { StickyTableCell } from 'components/table/tableCellStyles';

// sections
import { GridListHead, GridListToolbar } from 'sections/grid';

import DialogAbstract from './DialogAbstract';
import Cells from './cells';
import { Navigate } from 'react-router-dom';
import { formatError } from 'utils/formatError';
import helper from 'utils/helper';
import ConfirmDialog from './dialogs/ConfirmDialog';
import config from '../config';
import { debounce } from 'lodash';
import { GridDataAdapter } from '../adapters/GridDataAdapter';
import CheckboxCustom from '../components/checkbox';
import {
    AddCircleWhiteLinearIcon,
    DocumentDownloadLinearIcon,
    Edit1LinearIcon,
    TrashErrorLinearIcon
} from '../icons-lib';
import { HeaderWidget } from '../sections/header/HeaderWidget';
import { CustomTablePagination } from '../components/pagination/CustomTablePagination';

export default class GridPageAbstract extends React.Component {
    // Head is an array of objects with the following structure:
    // id - string, unique identifier of the field
    // label - string, label of the field
    // cell - string, type of the cell
    // disableGrid - boolean, if true, the field will not be displayed in the grid
    // disableEditor - boolean, if true, the field will not be displayed in the editor
    // object - string, if the field is an object, the name of the object,
    // uses with thr cell = 'Select'
    // display - string, which field to display in the grid
    // from - string, the name of the controller from server
    // filterCell - string, type of the filters cell ('Items' or 'Context')
    // filterBy - string, the name of the controller from server (with filterCell = 'Context')
    // items - array, the list of items for the filters (with filterCell = 'Items') or for the Items cell

    List = [];
    Head = [];
    Name = 'Grid';
    controllerName = '';
    Server = null;
    MenuDisplayType = 'menu' || 'none';
    hideSearch = true;
    exportButton = false;
    showHistoryFilters = false;
    historyFieldLabels = null;

    searchFields = [];
    baseFilterRequest = [];

    permissionName = '';

    userInfo = {};

    hideAddAction = false;
    hideEditAction = false;

    headerStartIcon = null;
    bannerImage = '';

    needsApproval = () => false;
    getToolbarActions = () => [];
    /* getHeaderActions is a function that returns an array of objects with the following structure:
     * title - string, title of the action
     * subtitle - string, subtitle of the action
     * icon - React component, icon of the action
     * onClick - function, action on click
     */
    getHeaderActions = () => [];

    customRetrieveData = () => {};

    constructor(props) {
        super(props);

        this.userInfo = props.context.getState().userInfo;

        this.state = {
            open: null,

            page: 0,
            rowsPerPage: 25,
            totalCount: 0,
            sortConfig: config.defaultSort,
            searchValue: '',
            searchFilters: [],
            filterRequest: [],
            historyFilterRequest: [],

            menuClickItemId: null,
            selected: [],

            alertText: null,
            snackbarOpen: false,

            isLoading: true,
            isDataLoading: false,
            isCsvExporting: false,

            dialogOpen: false,
            dialogData: {},

            openAddCouponsDialog: false,
            openAddInviteCodesDialog: false,

            navigateLink: false,

            openDateRange: false,
            dateRangeValue: '',

            permissions: this.props.context.getState().permissions || {},
            actions: this.props.context.getState().actions || {},

            confirmDialogOpen: false,
            confirmationType: ''
        };

        this.debouncedSearch = debounce(this.retrieveData, 500);
    }

    hasPermissions() {
        return !!Object.keys(this.state.permissions).length;
    }

    allowedPermission = (
        action,
        controller = helper.adaptedName(
            this.controllerName ? this.controllerName : this.Name
        )
    ) => {
        const permission = this.hasPermissions()
            ? this.state.permissions?.[controller]?.[action]
            : '';

        return permission && permission !== 'deny';
    };

    allowedAction = (action) => {
        if (Object.keys(this.state.actions).length === 0) return false;
        return this.state.actions[action] === 'allow';
    };

    mergedFilterRequest = (
        searchFilters,
        baseFilters,
        additionalFilters,
        historyFilters = []
    ) => {
        if (historyFilters.length) {
            return [historyFilters];
        }
        const combinedBaseFilters = [...baseFilters, ...additionalFilters];

        if (searchFilters.length) {
            return searchFilters
                .map((searchFilter) => searchFilter.concat(combinedBaseFilters))
                .filter((filter) => filter.length > 0);
        }
        return combinedBaseFilters.length > 0 ? [combinedBaseFilters] : [];
    };

    async fetchFilteredData() {
        const sort = this.Server.getSortField(
            this.state.sortConfig.field,
            this.state.sortConfig.direction || 'desc'
        );

        const filter = this.mergedFilterRequest(
            this.state.searchFilters,
            this.baseFilterRequest,
            this.state.filterRequest,
            this.state.historyFilterRequest
        );

        return await this.Server.getAllFiltered(filter, sort, {
            paging: {
                page: this.state.page,
                pageSize: this.state.rowsPerPage
            }
        });
    }

    async updateContextControllersData() {
        try {
            const contextState = this.props.context.getState();
            const controllersData = contextState.controllersData || {};
            const updates = {};
            const processedFields = new Set();

            const fetchPromises = this.Head.map(async (field) => {
                if (!field.from || processedFields.has(field.from)) return;

                // prevent duplicate fetches
                processedFields.add(field.from);

                // controller for permissions, field.from is the name for server controller
                const controller = helper.adaptedName(field.from);

                // if (!this.allowedPermission('read', controller)) return;

                if (!controllersData[controller]) {
                    const result = await this.props.context
                        .getState()
                        .server[field.from].getAll();
                    updates[field.from] = result.data;
                    updates[field.from + 'TotalCount'] = result.total_count;
                }
            });

            // updates[this.Name] = this.List;

            await Promise.all(fetchPromises);

            if (Object.keys(updates).length > 0) {
                this.props.context.update({
                    controllersData: {
                        ...controllersData,
                        ...updates
                    }
                });
            }
        } catch (error) {
            console.error(
                'An error occurred while updating context controllers data:',
                error
            );
        }
    }
    async preloadContextImages(files) {
        const currentState = this.props.context.getState();
        const images = { ...currentState.images };

        const imagePromises = files.map(async (file) => {
            if (!file) return;

            if (images[file.name]) return;

            try {
                const fileData = await currentState.server.files.getFile(
                    file.name
                );
                if (fileData.error !== 'OK') {
                    throw new Error(fileData.error);
                }
                images[file.name] = URL.createObjectURL(fileData.blob);
            } catch (error) {
                console.error(`Error loading file ${file.name}:`, error);
            }
        });

        await Promise.all(imagePromises);

        this.props.context.update({ images });
    }

    processListData(data) {
        const uniqueItems = new Set();
        this.List = data.filter((item) => {
            if (!item.id) {
                return false;
            }
            const isUnique = !uniqueItems.has(item.id);
            if (isUnique) uniqueItems.add(item.id);
            return isUnique;
        });
    }

    handleError(error) {
        this.setState({
            snackbarOpen: true,
            alertText: formatError(error)
        });
    }

    async retrieveData() {
        this.setState({ isLoading: true });

        try {
            const result = await this.fetchFilteredData();

            this.processListData(result.data);
            await this.customRetrieveData(this.List);

            if (result.error !== 'OK') {
                this.handleError(result);
                return;
            }

            if (this.state.page === 0) {
                this.setState({ totalCount: result.total_count });
            }

            await this.updateContextControllersData();
        } catch (error) {
            this.handleError(error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    handleExportDataToCsv = async () => {
        this.setState({ isCsvExporting: true });

        const sort = this.Server.getSortField(
            this.state.sortConfig.field,
            this.state.sortConfig.direction || 'desc'
        );
        const selectedItemsFilter =
            this.state.selected && this.state.selected.length > 0
                ? {
                      field: 'id',
                      op: '@',
                      value: this.state.selected
                  }
                : null;

        const filterReq = [
            ...this.state.filterRequest,
            ...(selectedItemsFilter ? [selectedItemsFilter] : [])
        ];
        const filter = this.mergedFilterRequest(
            this.state.searchFilters,
            this.baseFilterRequest,
            filterReq,
            this.state.historyFilterRequest
        );

        const result = await this.Server.export(filter, sort, {
            page: 0,
            pageSize: 200000
        });

        if (result.error !== 'OK' || !result.blob) {
            try {
                this.setState({
                    snackbarOpen: true,
                    alertText: formatError(result)
                });
                return;
            } catch (e) {
                this.setState({
                    snackbarOpen: true,
                    alertText:
                        'An unexpected error occurred while parsing server response.'
                });
                return;
            }
        }
        const { blob, filename } = result;

        try {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename || `${this.Name}.csv`;
            a.click();
            window.URL.revokeObjectURL(url);
        } finally {
            this.setState({ isCsvExporting: false });
        }
    };

    async componentDidMount() {
        this.setState({ isDataLoading: true });

        const { context } = this.props;

        this.unsubscribe = context.subscribe(() => {
            const newPermissions = context.getState().permissions;
            const newActions = context.getState().actions;
            if (this.state.permissions !== newPermissions) {
                this.setState({
                    permissions: newPermissions,
                    actions: newActions
                });
            }
        });

        try {
            // await this.updateContextControllersData();
            await this.retrieveData();
        } catch (error) {
            this.handleError(error);
        } finally {
            this.setState({ isDataLoading: false });
        }
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.context.getState().permissions !==
            this.props.context.getState().permissions
        ) {
            this.setState({
                permissions: this.props.context.getState().permissions,
                actions: this.props.context.getState().actions
            });
        }
    }

    componentWillUnmount() {
        this.unsubscribe();
        this.debouncedSearch.cancel();
    }

    handleFilterItems = async (filterRequest) => {
        const isFilterChanged =
            JSON.stringify(filterRequest) !==
            JSON.stringify(this.state.filterRequest);
        if (isFilterChanged) {
            this.setState({ filterRequest }, () => this.retrieveData());
        }
    };
    handleHistoryFilterItems = async (historyFilterRequest) => {
        const isFilterChanged =
            JSON.stringify(historyFilterRequest) !==
            JSON.stringify(this.state.historyFilterRequest);
        if (isFilterChanged) {
            this.setState(
                {
                    historyFilterRequest,
                    filterRequest: [],
                    searchFilters: [],
                    searchValue: ''
                },
                () => this.retrieveData()
            );
        }
    };

    handleSearch = (value) => {
        if (value === '') {
            this.setState({ searchFilters: [], searchValue: '' }, () =>
                this.retrieveData()
            );
            return;
        }
        const searchFilters = this.searchFields.map((field) => {
            if (field === 'id') {
                const valueInt = parseInt(value, 10);
                return [
                    {
                        field: field,
                        op: ':',
                        value: valueInt
                    }
                ];
            }
            return [{ field: field, op: ':', value: value }];
        });
        this.setState({ page: 0 });
        this.setState({ searchFilters, searchValue: value });
        this.debouncedSearch();
    };

    handleRequestSort = (sortField) => {
        this.setState((prevState) => {
            const { field, direction } = prevState.sortConfig;
            const isFieldChanged = field !== sortField;

            const newDirection = isFieldChanged
                ? 'asc'
                : direction === 'asc'
                ? 'desc'
                : direction === 'desc'
                ? this.state.sortConfig.direction ===
                      config.defaultSort.direction &&
                  this.state.sortConfig.field === config.defaultSort.field
                    ? 'asc'
                    : null
                : 'asc';

            const newField = isFieldChanged
                ? sortField
                : newDirection === null
                ? config.defaultSort.field
                : sortField;

            return {
                sortConfig: {
                    field: newField,
                    direction: newDirection
                }
            };
        }, this.retrieveData);
    };

    handleDownloadPdf() {
        const ids = this.state.selected.join(',');
        this.Server.getPdf(ids).then((response) => {
            if (response.error !== 'OK') {
                this.setState({
                    snackbarOpen: true,
                    alertText: formatError(response)
                });
            } else {
                this.setState({ selected: [] });
                window.open(URL.createObjectURL(response.blob));
            }
        });
    }

    handleOpenMenu(event, id) {
        this.setState({ open: event.currentTarget, menuClickItemId: id });
    }

    handleCloseMenu() {
        this.setState({ open: null, menuClickItemId: null });
    }

    handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = this.List.map((n) => n.id);
            this.setState({ selected: newSelected });
            return;
        }
        this.setState({ selected: [] });
    };
    handleDeselectAllClick = () => {
        this.setState({ selected: [] });
    };
    handleClick = (event, id) => {
        const selectedIndex = this.state.selected.indexOf(id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(this.state.selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(this.state.selected.slice(1));
        } else if (selectedIndex === this.state.selected.length - 1) {
            newSelected = newSelected.concat(this.state.selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                this.state.selected.slice(0, selectedIndex),
                this.state.selected.slice(selectedIndex + 1)
            );
        }
        this.setState({ selected: newSelected });
    };

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, () => this.retrieveData());
    };

    handleChangeRowsPerPage = (event) => {
        this.setState(
            { page: 0, rowsPerPage: parseInt(event.target.value, 10) },
            () => this.retrieveData()
        );
    };

    handleEditItem = (event) => {
        this.dialogOpen(
            this.List.filter(
                (item) => item.id === this.state.menuClickItemId
            ).at(0)
        );
    };

    handleDeleteItem = async (event) => {
        // single delete from right click menu
        // or multi deleted from selected by checkbox items
        let result = await this.Server.delete(
            this.state.menuClickItemId
                ? [this.state.menuClickItemId]
                : this.state.selected
        );
        this.setState({ menuClickItemId: null, open: false });
        if (result.error !== 'OK') {
            this.setState({
                snackbarOpen: true,
                alertText: formatError(result),
                selected: []
            });
        } else {
            this.setState({
                filterRequest: [],
                confirmDialogOpen: false,
                // confirmationType: '',
                selected: []
            });
            await this.retrieveData();
        }
    };

    handleApproveItem = async (event) => {
        let result = await this.Server.approve(
            this.state.menuClickItemId
                ? [this.state.menuClickItemId]
                : this.state.selected
        );
        if (result.error !== 'OK') {
            this.setState({
                snackbarOpen: true,
                alertText: formatError(result),
                selected: []
            });
        } else {
            this.setState({
                selected: [],
                confirmDialogOpen: false
                // confirmationType: ''
            });
            await this.retrieveData();
        }
    };

    changeStatus = async (data) => {
        let result = await this.Server.changeStatus(data);
        if (result.error !== 'OK') {
            this.setState({
                snackbarOpen: true,
                alertText: formatError(result),
                selected: [],
                open: null, // close menu
                menuClickItemId: null
            });
        } else {
            this.setState({
                selected: [],
                confirmDialogOpen: false,
                open: null, // close menu
                menuClickItemId: null
                // confirmationType: ''
            });
            await this.retrieveData();
        }
    };

    handleApproveDialogOpen = (event) => {
        this.setState({
            confirmDialogOpen: true,
            confirmationType: 'approve'
        });
    };

    handleActivateDialogOpen = (event) => {
        this.setState({
            confirmDialogOpen: true,
            confirmationType: 'active'
        });
    };

    handleDeclineDialogOpen = (event) => {
        this.setState({
            confirmDialogOpen: true,
            confirmationType: 'decline'
        });
    };

    handleRejectDialogOpen = (event) => {
        this.setState({
            confirmDialogOpen: true,
            confirmationType: 'rejected'
        });
    };

    handleDeleteConfirmDialogOpen = (event) => {
        this.setState({
            confirmDialogOpen: true,
            confirmationType: 'delete'
        });
    };

    handleReviewDialogOpen = (event) => {
        this.setState({
            confirmDialogOpen: true,
            confirmationType: 'review'
        });
    };
    handleChangeStatusDialogOpen = (event) => {
        this.setState({
            confirmDialogOpen: true,
            confirmationType: 'status'
        });
    };

    getCellValue = (row, field) => {
        // need to refactor this function
        if (field.type === 'merchantUpload') {
            return helper.transformUploadFiles(row[field.id]);
        }

        if (!field.object && row[field.id] !== undefined && row[field.id] !== null) {
            return row[field.id];
        }

        if (row[field.ifNull] !== undefined && row[field.ifNull] !== null) {
            return row[field.ifNull];
        }

        return row?.[field.object];
    };

    hasMenuItems() {
        const customMenuItems = this.renderCustomMenuItems();
        return (
            this.allowedPermission('update') ||
            this.allowedPermission('delete') ||
            (Array.isArray(customMenuItems) && customMenuItems.length > 0)
        );
    }

    renderGridSingleRow(row) {
        const { id } = row;
        const currentRole = this.userInfo.role;
        const selectedUser = this.state.selected.indexOf(id) !== -1;
        const tableFields = this.Head.filter((f) => !f.disableGrid).filter(
            (f) => (f.role ? f.role === currentRole : true)
        );

        const hasMenuItems = this.hasMenuItems();

        return (
            <TableRow
                hover
                key={id}
                tabIndex={-1}
                role="checkbox"
                selected={selectedUser}
            >
                <TableCell
                    key="checkbox"
                    sx={{ borderRight: '1px solid #f2f4f4' }}
                    align="center"
                >
                    <CheckboxCustom
                        id={id + 'checkbox'}
                        checked={selectedUser}
                        onChange={(event) => this.handleClick(event, id)}
                    />
                </TableCell>

                {tableFields.map((field) => {
                    let Cell = Cells[field.cell];
                    if (!Cell) Cell = Cells.Text; // fallback to text cell
                    if (field.disableGrid) return <></>;
                    let value = this.getCellValue(row, field);
                    return (
                        <Cell
                            key={field.id}
                            id={row.id}
                            row={row}
                            value={value}
                            field={field}
                            actions={this.state.actions}
                            handleChange={this.handleChangeCell}
                            handleSave={this.handleSaveCell}
                            currentValues={this.state.currentValues}
                            refresh={() => this.retrieveData()}
                            context={this.props.context}
                        />
                    );
                })}
                <StickyTableCell
                    key="menu"
                    align="right"
                    sx={{
                        borderLeft: (theme) =>
                            `1px solid ${theme.palette.divider}`
                    }}
                >
                    {hasMenuItems && (
                        <IconButton
                            size="large"
                            color="inherit"
                            onClick={(event) => this.handleOpenMenu(event, id)}
                        >
                            <Iconify icon={'eva:more-horizontal-fill'} />
                        </IconButton>
                    )}
                </StickyTableCell>
            </TableRow>
        );
    }

    renderGridBodyRows() {
        return (
            <>
                {this.List.map((row) => {
                    return this.renderGridSingleRow(row);
                })}
            </>
        );
    }

    renderGridBodyNotFound() {
        const emptyCol = this.Head.length + 2;
        return (
            <>
                <TableBody>
                    <TableRow>
                        <TableCell
                            align="center"
                            colSpan={emptyCol}
                            sx={{ py: 3 }}
                        >
                            <Paper
                                sx={{
                                    textAlign: 'center'
                                }}
                            >
                                <Typography variant="h6" paragraph>
                                    Not found
                                </Typography>

                                <Typography variant="body2">
                                    No results found for &nbsp;
                                    <strong>
                                        &quot;{this.state.searchValue}&quot;
                                    </strong>
                                    .
                                    <br /> Try checking for typos or using
                                    complete words.
                                </Typography>
                            </Paper>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </>
        );
    }

    renderCustomMenuItems() {
        return <></>;
    }

    renderMenuPopover() {
        return (
            <>
                <Popover
                    open={Boolean(this.state.open)}
                    anchorEl={this.state.open}
                    onClose={(event) => this.handleCloseMenu(event)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    PaperProps={{
                        sx: {
                            p: 1,
                            minWidth: 150,
                            maxWidth: 220,
                            border: '1px solid #D0D5DD',
                            '& .MuiMenuItem-root': {
                                px: 1,
                                typography: 'body2',
                                borderRadius: 0.75
                            }
                        }
                    }}
                >
                    {this.renderCustomMenuItems()}

                    {this.allowedPermission('update') &&
                        !this.hideEditAction && (
                            <MenuItem
                                onClick={(event) => this.handleEditItem(event)}
                                key="edit"
                            >
                                <Edit1LinearIcon sx={{ mr: 2 }} />
                                {i18n.t('buttons.edit')}
                            </MenuItem>
                        )}

                    {this.allowedPermission('delete') &&
                        !this.hideDeleteAction && (
                            <MenuItem
                                onClick={(event) =>
                                    this.handleDeleteConfirmDialogOpen(event)
                                }
                                sx={{ color: 'error.main' }}
                                key="delete"
                            >
                                <TrashErrorLinearIcon
                                    sx={{ mr: 2, color: '#F63D68' }}
                                />
                                {i18n.t('buttons.delete')}
                            </MenuItem>
                        )}
                </Popover>
            </>
        );
    }

    renderCustom() {
        return <></>;
    }

    render() {
        const filteredHead = this.Head.filter((f) => !f.disableGrid).filter(
            (f) => (f.role ? f.role === this.userInfo.role : true)
        );

        const isNotFound =
            !this.List && !this.List.length && this.state.searchValue;
        if (this.state.isDataLoading) {
            return (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: 'rgba(255, 255, 255, 0.7)',
                        zIndex: 2
                    }}
                >
                    <CircularProgress />
                </Box>
            );
        }

        let isCreateAllowed = this.allowedPermission('create');
        const headerActions = this.getHeaderActions();
        return (
            <>
                {this.state.navigateLink && (
                    <Navigate to={this.state.navigateLink} />
                )}

                {this.renderCustom()}

                {this.renderDialog()}

                {this.renderConfirmDialog()}

                <Helmet>
                    <title>
                        {helper.formPageTitle(`pages.${this.Name}.title`)}
                    </title>
                </Helmet>

                <Container maxWidth={false}>
                    <Box mb={3}>
                        <HeaderWidget
                            title={i18n.t(`pages.${this.Name}.title`)}
                            subtitle={i18n.t(`pages.${this.Name}.subtitle`)}
                            startIcon={this.headerStartIcon}
                            image={this.bannerImage}
                            actions={[
                                isCreateAllowed &&
                                    !this.hideAddAction && {
                                        title: i18n.t(`pages.${this.Name}.add`),
                                        icon: <AddCircleWhiteLinearIcon />,
                                        onClick: () => this.dialogOpen()
                                    },
                                ...headerActions
                            ].filter(Boolean)}
                        />
                    </Box>

                    <Card>
                        <GridListToolbar
                            Head={this.Head}
                            totalCounter={this.state.totalCount}
                            numSelected={this.state.selected.length}
                            deselectAll={() => this.handleDeselectAllClick()}
                            searchValue={this.state.searchValue}
                            handleSearchData={this.handleSearch}
                            hideSearch={this.hideSearch}
                            exportButton={this.exportButton}
                            exportDataToCsv={() => this.handleExportDataToCsv()}
                            isCsvExporting={this.state.isCsvExporting}
                            role={this.userInfo.role}
                            handleFilterItems={(filterReq) =>
                                this.handleFilterItems(filterReq)
                            }
                            loading={this.state.isLoading}
                            filters={this.state.filterRequest}
                            handleHistoryFilterItems={(filterReq) =>
                                this.handleHistoryFilterItems(filterReq)
                            }
                            historyFilters={this.state.historyFilterRequest}
                            showHistoryFilters={this.showHistoryFilters}
                            historyFieldLabels={this.historyFieldLabels}
                            actions={[
                                this.allowedPermission('delete') && {
                                    title: i18n.t('buttons.delete'),
                                    onClick: () =>
                                        this.handleDeleteConfirmDialogOpen()
                                },
                                this.exportButton && {
                                    title: i18n.t('buttons.exportCsv'),
                                    onClick: () => this.handleExportDataToCsv(),
                                    icon: <DocumentDownloadLinearIcon />
                                },
                                ...this.getToolbarActions()
                            ].filter(Boolean)}
                        />
                        <Scrollbar sx={{ background: '#fff' }}>
                            {this.state.isLoading && (
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        background: 'rgba(255, 255, 255, 0.7)',
                                        zIndex: 2
                                    }}
                                >
                                    <CircularProgress />
                                </Box>
                            )}
                            <TableContainer
                                sx={{
                                    overflowX: 'initial',
                                    minWidth: 800,
                                    width: '100%',
                                    height: '100%'
                                }}
                            >
                                <Table stickyHeader>
                                    <GridListHead
                                        order={
                                            this.state.sortConfig.direction ||
                                            'desc'
                                        }
                                        orderBy={this.state.sortConfig.field}
                                        headLabel={filteredHead}
                                        rowCount={this.List.length}
                                        numSelected={this.state.selected.length}
                                        onRequestSort={this.handleRequestSort}
                                        onSelectAllClick={
                                            this.handleSelectAllClick
                                        }
                                        showMenu={
                                            this.MenuDisplayType === 'menu'
                                        }
                                    />
                                    <TableBody>
                                        {this.renderGridBodyRows()}
                                    </TableBody>

                                    {isNotFound &&
                                        this.renderGridBodyNotFound()}
                                </Table>
                            </TableContainer>
                        </Scrollbar>
                        <CustomTablePagination
                            component="div"
                            count={this.state.totalCount}
                            rowsPerPage={this.state.rowsPerPage}
                            page={this.state.page}
                            onPageChange={this.handleChangePage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                        />
                    </Card>
                </Container>

                {this.renderMenuPopover()}

                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right'
                    }}
                    open={this.state.snackbarOpen}
                    onClose={() => this.handleSnackbarClose()}
                >
                    <Alert
                        onClose={() => this.handleSnackbarClose()}
                        severity="error"
                        sx={{ width: '100%' }}
                    >
                        {this.state.alertText}
                    </Alert>
                </Snackbar>
            </>
        );
    }

    handleSnackbarClose() {
        this.setState({ snackbarOpen: false });
    }

    dialogOpen(data) {
        let dialogFields;

        if (data) {
            dialogFields = this.Head.filter((f) => !f.disableEditor);
        } else {
            dialogFields = this.Head.filter(
                (f) => !f.disableEditor || (f.disableEditor && f.displayAdd)
            );
        }
        let dialogData = GridDataAdapter.transform(data, dialogFields);
        this.setState({
            dialogOpen: true,
            dialogData: dialogData,
            open: false
        });
    }

    async handleDialogOnSave(data) {
        this.setState({ dialogOpen: false, dialogData: null });
        await this.retrieveData();
    }

    async handleDialogOnClose() {
        this.setState({ dialogOpen: false, dialogData: null });
    }

    renderConfirmDialog() {
        // dialog type: delete, approve, decline
        const dialogType = this.state.confirmationType;
        if (dialogType === 'delete') {
            return (
                <ConfirmDialog
                    dialogOpen={this.state.confirmDialogOpen}
                    onConfirm={() => this.handleDeleteItem()}
                    onCancel={() =>
                        this.setState({
                            // confirmationType: '',
                            confirmDialogOpen: false
                        })
                    }
                    type={this.state.confirmationType}
                    title={i18n.t('dialogs.confirmationDeleteTitle')}
                    subtitle={i18n.t('dialogs.confirmationDeleteSubtitle')}
                    confirmLabel={i18n.t('buttons.delete')}
                />
            );
        }
        if (dialogType === 'approve') {
            return (
                <ConfirmDialog
                    dialogOpen={this.state.confirmDialogOpen}
                    onConfirm={() => this.handleApproveItem()}
                    onCancel={() =>
                        this.setState({
                            // confirmationType: '',
                            confirmDialogOpen: false
                        })
                    }
                    type={this.state.confirmationType}
                    title={i18n.t('dialogs.confirmationApproveTitle')}
                    subtitle={i18n.t('dialogs.confirmationApproveSubtitle')}
                    confirmLabel={i18n.t('buttons.approve')}
                />
            );
        }
        if (dialogType === 'active') {
            return (
                <ConfirmDialog
                    dialogOpen={this.state.confirmDialogOpen}
                    onConfirm={(status) => this.handleChangeStatus(status)}
                    onCancel={() =>
                        this.setState({
                            // confirmationType: '',
                            confirmDialogOpen: false
                        })
                    }
                    type={this.state.confirmationType}
                    accentColor="primary"
                    title={i18n.t('dialogs.confirmationApproveTitle')}
                    subtitle={i18n.t('dialogs.confirmationApproveSubtitle')}
                    confirmLabel={i18n.t('buttons.approve')}
                />
            );
        }
        if (dialogType === 'decline' || dialogType === 'rejected') {
            return (
                <ConfirmDialog
                    dialogOpen={this.state.confirmDialogOpen}
                    showInput={true}
                    onConfirm={(status) => this.handleChangeStatus(status)}
                    onCancel={() =>
                        this.setState({
                            // confirmationType: '',
                            confirmDialogOpen: false
                        })
                    }
                    type={this.state.confirmationType}
                    title={i18n.t('dialogs.confirmationDeclineTitle')}
                    subtitle={i18n.t('dialogs.confirmationDeclineSubtitle')}
                    confirmLabel={i18n.t('buttons.decline')}
                />
            );
        }
        if (dialogType === 'review') {
            return (
                <ConfirmDialog
                    dialogOpen={this.state.confirmDialogOpen}
                    onConfirm={(status) => this.handleChangeStatus(status)}
                    onCancel={() =>
                        this.setState({
                            // confirmationType: '',
                            confirmDialogOpen: false
                        })
                    }
                    accentColor="primary"
                    type={this.state.confirmationType}
                    title={i18n.t('dialogs.confirmationReviewTitle')}
                    subtitle={i18n.t('dialogs.confirmationReviewSubtitle')}
                    confirmLabel={i18n.t('buttons.review')}
                />
            );
        }
        if (dialogType === 'status') {
            return (
                <ConfirmDialog
                    dialogOpen={this.state.confirmDialogOpen}
                    onConfirm={(status) => this.handleChangeStatus(status)}
                    onCancel={() =>
                        this.setState({
                            // confirmationType: '',
                            confirmDialogOpen: false
                        })
                    }
                    type={this.state.confirmationType}
                    title={i18n.t('dialogs.confirmationStatusTitle')}
                    subtitle={i18n.t('dialogs.confirmationStatusSubtitle')}
                    confirmLabel={i18n.t('buttons.changeStatus')}
                />
            );
        }
        return <></>;
    }

    renderDialog() {
        return (
            <DialogAbstract
                dialogOpen={this.state.dialogOpen}
                dialogData={this.state.dialogData}
                permissions={this.permissions}
                Name={this.Name}
                Head={this.Head}
                Server={this.Server}
                onSave={(data) => this.handleDialogOnSave(data)}
                onClose={() => this.handleDialogOnClose()}
            />
        );
    }
}
